export const getMultisafeAccountId = (name) => `${name}`;
